import React, {useCallback, useEffect, useState, useRef} from "react";
import axios from "axios";
import PropTypes from 'prop-types';
import { jwtDecode } from 'jwt-decode'
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"

const DatasourceSalesforce = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 
    
    const [mLoginType, SetLoginType] = useState("OAuth") 

    const cClientId = "3MVG9fTLmJ60pJ5JzlQQuXqJ3uA9d4uWUZypRbJ3dV3107bf0Xsm41HzAc35h7Atfxna5uAdEbcmjjiadIbhE"
    const cClientSecret = "042C068CDB1D9CF7792565CBD8475BBA5A0D31CCD4F4255873B29A7B78CA9AD3"
    const cDefaultSoapUrl = "https://login.salesforce.com/services/Soap/u/43.0"
      
    const cOAuthUrlBase = "https://login.salesforce.com/services/oauth2/authorize" +
        "?client_id=" + cClientId +
        "&response_type=code" +
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2"

    useEffect(() => {
        UpdateDatasourceSetting(3,"DatasourceVersion") 
        SetReady()  
      }, []); 

    const UpdateDatasourceSetting = (aValue,aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue

        SetReady()
    }

    const UpdateLoginType = (aValue) =>
    {
        SetLoginType(aValue)

        if (aValue === "OAuth")
        {
            props.IntegrationSettings.DatasourceSettings.UserName = ""
            props.IntegrationSettings.DatasourceSettings.Password = ""
            props.IntegrationSettings.DatasourceSettings.Token = ""
            props.IntegrationSettings.DatasourceSettings.SoapUrl = ""
        }
        else if (aValue === "SOAP")
        {
            props.IntegrationSettings.DatasourceSettings.RefreshToken = ""
            props.IntegrationSettings.DatasourceSettings.SoapUrl = !IsEmptyString(props.IntegrationSettings.DatasourceSettings.SoapUrl) ? props.IntegrationSettings.DatasourceSettings.SoapUrl : cDefaultSoapUrl
        }

        SetReady()
    }

    const SetReady = () => 
    {
        const Ready = ((mLoginType === "OAuth") && props.IntegrationSettings.DatasourceSettings["RefreshToken"])
            || ((mLoginType === "SOAP") && props.IntegrationSettings.DatasourceSettings["UserName"] && props.IntegrationSettings.DatasourceSettings["Password"] && props.IntegrationSettings.DatasourceSettings["Token"] && props.IntegrationSettings.DatasourceSettings["SoapUrl"])

        props.OnSetReady(Ready)
    }

    async function GetTokens(aAuthorizationCode) 
    {
          let Result = await ConfigurationApiForward(
            props.SecurityToken, 
            "https://login.salesforce.com/services/oauth2/token", 
            "POST", 
            "client_id=" + cClientId + "&client_secret=" + cClientSecret + "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2&grant_type=authorization_code&code=" + aAuthorizationCode, 
            "application/json", 
            "application/x-www-form-urlencoded")
        if (Result != null)
        {
            UpdateDatasourceSetting(Result.data.refresh_token,"RefreshToken")        
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }

        SetWaitingForState("")
        SetReady()
    }

    const OAuthPollResult = (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success: " + JSON.stringify(aValue))
            if (aValue.Code && aValue.ResponseUrl)
            {
                GetTokens(aValue.Code)
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error: " + JSON.stringify(aValue))  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const OAuthUrl = cOAuthUrlBase + "&state=" + State
        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        OAuthApiStopPolling()
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}

        SetWaitingForState("")
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    return (
        <div className="scriptitembody">

            <div className="wizardfieldvalue">
                <select name="LoginType" onChange={evt => UpdateLoginType(evt.target.value)} className={"wizardinputfield"}>
                    <option value="OAuth" checked={mLoginType === "OAuth"}>{Translate("Signin with OAuth")}</option>
                    <option value="SOAP" checked={mLoginType === "SOAP"}>{Translate("Signin with username and password")}</option>
                </select>
            </div>
            <br/>
            {mLoginType === "OAuth" ?
                <>
                    {props.IntegrationSettings.DatasourceSettings.RefreshToken ? <div className="scriptitembody">
                        {Translate("$Application connection token received succesfully").replace("$Application","Salesforce")}
                    </div> :
                    (mError ?
                        //Authorization failed. Show error and connect button
                        <div className="scriptitembody">
                            <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                            <div>{mError}</div>
                        </div> :
                        (mWaitingForState ?
                            //Waiting for authorization. Show dot counter and cancel button
                            <div className="scriptitembody">
                                <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                                <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                            </div> :
                            //Not authenticating. Show connect button
                            <div className="scriptitembody">
                                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
                            </div>
                        )
                    )}
                </>
                :
                <>
                    <div className="wizardfieldname">{Translate("Username").toUpperCase()}</div>
                    <div className="wizardfieldvalue"><input autoComplete="salesforce_username" type="text" value={props.IntegrationSettings.DatasourceSettings.UserName || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "UserName")} className="wizardinputfield"/></div> 
                    <div className="wizardfieldname">{Translate("Password").toUpperCase()}</div>
                    <div className="wizardfieldvalue"><input autoComplete="salesforce_password" type="text" value={props.IntegrationSettings.DatasourceSettings.Password || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Password")} className="wizardinputfield"/></div>    
                    <div className="wizardfieldname">{Translate("Security token").toUpperCase()}</div>
                    <div className="wizardfieldvalue"><input autoComplete="salesforce_token" type="text" value={props.IntegrationSettings.DatasourceSettings.Token || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Token")} className="wizardinputfield"/></div>    
                    <div className="wizardfieldname">SOAP URL</div>
                    <div className="wizardfieldvalue"><input autoComplete="salesforce_soapurl" type="text" value={props.IntegrationSettings.DatasourceSettings.SoapUrl || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "SoapUrl")} className="wizardinputfield"/></div>          
                </>}      
        </div>  
    )
}

DatasourceSalesforce.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceSalesforce